import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { isObject } from 'lodash'

dayjs.locale('ru')
let scripts = {}

export function extractDatetime(event) {
  return {
    start: event.start.format('YYYY-MM-DD HH:mm:ss'),
    end: event.end.format('YYYY-MM-DD HH:mm:ss')
  }
}

export function createDatetimeFromStart(start, duration) {
  return {
    start: start.clone(),
    end: start.clone().add(duration, 'minutes')
  }
}

export function arraySwap(arr, index1, index2) {
  // eslint-disable-next-line
  ;[arr[index1], arr[index2]] = [arr[index2], arr[index1]]
  return arr
}

export function createStartEndDate(event) {
  let stime = event.startTime.split(/:/)
  let etime = event.endTime.split(/:/)

  return {
    start: dayjs(event.startDate)
      .set('hour', stime[0])
      .set('minute', stime[1]),
    end: dayjs(event.endDate)
      .set('hour', etime[0])
      .set('minute', etime[1])
  }
}

export function loadScript(url, callback) {
  if (scripts[url]) {
    return callback()
  }

  let script = document.createElement('script')

  if (script.readyState) {
    script.onreadystatechange = function() {
      if (script.readyState == 'loaded' || script.readyState == 'complete') {
        script.onreadystatechange = null
        scripts[url] = url

        callback()
      }
    }
  } else {
    script.onload = function() {
      scripts[url] = url
      callback()
    }
  }

  script.src = url
  document.getElementsByTagName('head')[0].appendChild(script)
}

export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return (
    s4() +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    '-' +
    s4() +
    s4() +
    s4()
  )
}

export function getBoundingBoxCenter(selection) {
  let element = selection.node()
  let bbox = element.getBBox()
  return [bbox.x + bbox.width / 2, bbox.y + bbox.height / 2]
}

export function isUrlValid(userInput) {
  let res = userInput.match(
    /^((http|https):\/\/)?[a-zа-я0-9]+([-.]{1}[a-zа-я0-9]+)*\.[a-zа-я]{2,5}(:[0-9]{1,5})?(\/.*)?$/i
  )
  if (res == null) return false
  else return true
}

export function declOfNum(number, titles) {
  let cases = [2, 0, 1, 1, 1, 2]
  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ]
}

export function createFormData(values) {
  let data = new FormData()

  Object.keys(values).forEach(key => {
    data.append(
      key,
      isObject(values[key]) ? JSON.stringify(values[key]) : values[key]
    )
  })

  return data
}

export function generatePassword() {
  let length = 8
  let charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let retVal = ''

  for (let i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n))
  }

  return retVal
}

export function createTreeStruct(arr, parent) {
  let out = []

  for (let i in arr) {
    if (arr[i].parent_id == parent) {
      let children = createTreeStruct(arr, arr[i].id)
      arr[i].children = []

      if (children.length) {
        arr[i].children = children
      }

      out.push(arr[i])
    }
  }

  return out
}

export function getGeocoderResults(response) {
  try {
    const { address } = response[0].properties
    let displayName = null

    if (address.state) {
      displayName = `${address.state}`
    }

    if (address.city) {
      displayName += `, ${address.city}`
    }

    if (address.road) {
      displayName += `, ${address.road}`
    }

    if (address.house_number) {
      displayName += `, д.${address.house_number}`
    }

    return displayName
  } catch (e) {
    return null
  }
}
